import React from 'react';
import { User } from 'models/User';
import { DeleteUserCell } from '../../../components/UserTableCells/UserTableCells.component';

type TableCols = Array<
  keyof Pick<User, 'firstName' | 'lastName' | 'email'> | 'delete'
>;

export const columns: TableCols = ['firstName', 'lastName', 'email', 'delete'];

export const headingTranslations: Record<TableCols[number], string> = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  delete: 'delete',
};

export const contentTransformations: Record<
  TableCols[number],
  (val: any, config?: Record<string, any>) => React.ReactNode
> = {
  firstName: (v) => v,
  lastName: (v) => v,
  email: (v) => v,
  delete: (v, conf) => <DeleteUserCell val={v} config={conf} />,
};
